export default __webpack_public_path__ + "static/media/send_failed.14c773d4.svg";